exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header {\n  background-color: #1594A6;\n  height: 64px;\n  margin-bottom: 10px;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2); }\n\n.img-height {\n  padding: 10px 0;\n  background-color: #ffffff;\n  margin-top: 0px;\n  padding: 0px;\n  height: 64px;\n  width: 64px; }\n\n.brand-logo {\n  float: left; }\n\n.refresh-icon {\n  font-size: 40px;\n  line-height: 1.5;\n  margin-right: 10px;\n  color: white;\n  cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/stakeholder-header/stakeholder-header.component.scss
// module id = ../../../../../src/app/components/stakeholder-header/stakeholder-header.component.scss
// module chunks = main